import $ from "jquery";
import { getVideoId } from "../utils/functions";
import { openModal } from "./modal";

const $page = $(".page");
const $videoPlayerEl = $(".video-player");
const players = [];

$(function () {
  if ($videoPlayerEl.length > 0) {
    loadVideoPlayers().then(function () {
      $videoPlayerEl.each(function () {
        videoPlayer($(this));
      });
      loadYTIframeApi();
    });
  }
});

const loadVideoPlayers = async () => {
  for (const player of $videoPlayerEl) {
    const url = $(player).data("url");
    const id = "video-" + getVideoId(url);

    if (!players.includes(id)) {
      players.push(id);

      const filter = {
        url: url,
      };

      await renderVideoPlayer(filter);
    }
  }
};

const renderVideoPlayer = async (filter) => {
  const data = await getVideoPlayer(filter);
  $page.append(data.html);
};

const getVideoPlayer = async (filter) => {
  try {
    const response = await fetch(
      SITE_PARAMS.site_url + "/wp-json/vuvh/v1/video-player/html",
      {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(filter),
      }
    );
    const result = await response.json();
    return result;
  } catch (e) {
    console.log(e);
    return null;
  }
};

const videoPlayer = (videoPlayerEl) => {
  const id = getVideoId(videoPlayerEl.data("url"));
  const $modal = $("#modal-" + id);
  const iframeId = "video-" + id;
  const $iframe = $("#" + iframeId);

  $iframe.one("iframe:ready", function () {
    videoPlayerEl.on("click", function () {
      openModal($modal);
      $modal.one("modal:opened", function () {
        players[iframeId].playVideo();
      });
      $modal.one("modal:closing", function () {
        players[iframeId].pauseVideo();
      });
    });
  });
};

const loadYTIframeApi = () => {
  let tag = document.createElement("script");
  tag.type = "text/javascript";
  tag.id = "yt-iframe-api";
  tag.src = "https://www.youtube.com/iframe_api";

  let firstScriptTag = document.getElementsByTagName("script")[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
};

window.onYouTubeIframeAPIReady = function () {
  players.forEach(function (el) {
    players[el] = new YT.Player(el, {
      events: { onReady: onPlayerReady },
    });
  });
};

function onPlayerReady(event) {
  $(event.target.h).trigger("iframe:ready");
}
